import { isEqual } from "lodash";
import { h } from "preact";
import {
  IWidgetConfigurationProps,
  withWidgetConfiguration,
} from "../../../node_modules/@sgwt-widget/core";
import { IHeader } from "../../common/components/AgGrid/index";
import { PivotAgGrid } from "../../common/components/AgGrid/PivotAgGrid";
import { ApiBackedComponent } from "../../common/components/ApiBackedComponent";
import {
  MakeGenericApiCall,
  MakeSalesCreditRoleProfile,
} from "../../common/generic/generic-api";
import {
  CheckReponseDataForError,
  GenericFilterBuilder,
  isNotNullOrEmpty,
} from "../../common/generic/generic-helper";
import { NbiDimensions } from "../../common/generic/generic-nbi-dimensions";
import {
  IFilterItem,
  IGenericRequest,
} from "../../common/generic/generic-types";
import {
  BuildPortfolioFilters,
  GetPortfolioFilterAsofDate,
} from "../../common/portfolio/portfolio-filter";
import { IPortfolioClientList } from "../../common/portfolio/portfolio-types";
import {
  getColumnSelected,
  reOrderArray,
  reOrderArrayObj,
} from "../../common/utils/clientlistHelper";
import {
  ICommonClientList,
  IClientAccount,
  IHeaders,
} from "../../common/utils/types";
import { getAllAttributes, getDefaultAttributes } from "../utils/Attributes";
import { getAllHeaders } from "../utils/Headers";
import {
  getDefaultHeaders,
  MapData,
  widgetNames,
  NbiClientListOutput,
} from "../utils/helper";
import { getAllKpis, getDefaultKpis } from "../utils/Kpis";
import { AgGridUserPreference } from "../../common/sg-dashboard/userPreference/userPreference.typings";
export interface PortfolioClientListProps {
  filters?: { [attribute: string]: string[] | string | IClientAccount[] };
  headers: IHeaders;
  attribute?: string;
  userSelection: AgGridUserPreference;
  onColumnsMoved?: (value: AgGridUserPreference) => void;
}

interface PortfolioClientListState extends ICommonClientList {
  data: IPortfolioClientList[];
  headers: IHeader[];
  kpis: string;
  columnState: any;
  gridOptions: any;
  defaultColState: string;
  autoGroupColumnDef: {};
  newData: any[];
  filter: string;
  blList: string[];
  filters: string;
}
const defAttributes = `clientgen_id,clientgen_name,fpv_bl,fpv_sbl`;
const defaultKpis =
  "nbi_ytd,nbi_ytd_1,nbi_mtd,nbi_mtd_1,nbi_forcast_h1,nbi_forcast_y1" +
  +",nbi_rwa_avg, nbi_forcast_rwa_y1, nbi_rgcp, nbi_rgcp_1, nbi_nbi, nbi_yoy";
const attr = new NbiDimensions();
const indicator = "nbi";

export class PortfolioClientListClass extends ApiBackedComponent<
  PortfolioClientListProps & IWidgetConfigurationProps,
  PortfolioClientListState
> {
  private attributes?: [{ field: string; headerName: string }];
  private kpis?: [{ field: string; headerName: string }];
  private isFromClientScreen = false;
  private isFromGroupScreen = false;

  public constructor() {
    super();
    this.setState({
      data: [],
      rowGroupColumns: defAttributes.split(","),
      valueColumns: defaultKpis.split(","),
    });
    this.columnOrderChanged = this.columnOrderChanged.bind(this);
  }

  protected shouldFetchApiData(nextProps: PortfolioClientListProps): boolean {
    this.isFromClientScreen = this.isFromClientScreenCheck(nextProps);
    this.isFromGroupScreen = this.isFromGroupScreenCheck(nextProps);

    if (isEqual(this.props.filters, nextProps.filters)) {
      return false;
    } else if (
      this.checkClientFilters(nextProps) ||
      this.checkPortfolioFilters(nextProps) ||
      this.checkClientGroupFilters(nextProps)
    ) {
      return false;
    }
    return true;
  }

  protected renderWithDataReady(): JSX.Element {
    return (
      <div style="height: 88%; overflow:hidden;">
        <PivotAgGrid
          rowData={this.state.data}
          columnDefs={this.state.headers}
          fileName={"portfolio"}
          rowGroupColumns={this.state.rowGroupColumns}
          valueColumns={this.state.valueColumns}
          showExcelToExport={true}
          attrsCount={this.state.visibleAttributes.length}
          columnOrderChanged={userPreference =>
            this.columnOrderChanged(userPreference)
          }
          userSelection={this.props.userSelection}
        />
      </div>
    );
  }

  protected async fetchApiData(props: PortfolioClientListProps) {
    this.initCorrelationId();
    const widgetName = this.isFromGroupScreen
      ? widgetNames.CLIENTGROUP
      : this.isFromClientScreen
      ? widgetNames.CLIENTSNAPSHOT
      : widgetNames.PORTFOLIO;
    let allHeaders: any = [];
    const filters = BuildPortfolioFilters(props.filters);
    const headers = props.headers;
    this.setState({
      data: [],
    });

    const isClientMandatory =
      props.attribute === attr.CLIENT_GEN_ID &&
      filters.filter(x => x.attribute === attr.CLIENT_GEN_ID).length === 0;

    if (isClientMandatory) {
      this.setState({
        data: [],
      });
      this.setDataStatus("no-client");
      return;
    }

    this.setDataStatus("loading");

    this.attributes = getDefaultAttributes(widgetName);
    this.kpis = getDefaultKpis();
    this.setState({ filters: GenericFilterBuilder(filters) });
    this.setState({ visibleAttributes: this.attributes });
    this.setState({ visibleKpis: this.kpis });
    this.setState(
      (prevState: PortfolioClientListState, _: PortfolioClientListProps) => ({
        rowGroupColumns: prevState.visibleAttributes,
      })
    );
    this.setState(
      (prevState: PortfolioClientListState, _: PortfolioClientListProps) => ({
        valueColumns: prevState.visibleKpis,
      })
    );

    allHeaders = getDefaultHeaders(widgetName);
    const nbiReferentiel = getAllHeaders(widgetName).attributeHeaders.concat(
      getAllHeaders(widgetName).kpiHeaders
    );
    let columnsSelected = getColumnSelected(
      props.filters,
      props.userSelection,
      nbiReferentiel
    );

    if (columnsSelected === undefined || columnsSelected.length === 0) {
      columnsSelected = this.attributes
        .map(x => x.headerName)
        .concat(this.kpis.map(x => x.headerName));
    }

    this.setState({
      visibleAttributes: getAllAttributes().filter(
        x => columnsSelected.indexOf(x.headerName) > -1
      ),
    });

    if (!isNotNullOrEmpty(this.state.visibleAttributes)) {
      this.setDataStatus("no-attribute-selected");
      return;
    }
    this.setState(
      (prevState: PortfolioClientListState, _: PortfolioClientListProps) => ({
        visibleAttributes: reOrderArray(
          prevState.visibleAttributes,
          columnsSelected
        ),
      })
    );
    this.setState({
      visibleKpis: getAllKpis().filter(
        x => columnsSelected.indexOf(x.headerName) > -1
      ),
    });
    if (!isNotNullOrEmpty(this.state.visibleKpis)) {
      this.setDataStatus("no-kpi-selected");
      return;
    }
    this.setState(
      (prevState: PortfolioClientListState, _: PortfolioClientListProps) => ({
        visibleKpis: reOrderArray(prevState.visibleKpis, columnsSelected),
      })
    );
    this.setState(
      (prevState: PortfolioClientListState, _: PortfolioClientListProps) => ({
        rowGroupColumns: prevState.visibleAttributes,
      })
    );
    this.setState(
      (prevState: PortfolioClientListState, _: PortfolioClientListProps) => ({
        valueColumns: prevState.visibleKpis,
      })
    );
    let attributeHeaders = getAllHeaders(widgetName).attributeHeaders.filter(
      (x: any) => columnsSelected.indexOf(x.headerName) > -1
    );
    attributeHeaders = reOrderArrayObj(
      attributeHeaders,
      columnsSelected,
      "headerName"
    );

    let kpiHeaders = getAllHeaders("").kpiHeaders.filter(
      (x: any) => columnsSelected.indexOf(x.headerName) > -1
    );
    kpiHeaders = reOrderArrayObj(kpiHeaders, columnsSelected, "headerName");
    allHeaders = [].concat.apply(attributeHeaders, kpiHeaders);

    const date = GetPortfolioFilterAsofDate(props.filters);
    const kpiandheader: any[] = this.checkKpisForVariation(
      this.state.visibleKpis
    );

    let kpis = kpiandheader[0].toString();
    const headersForVariation: any[] = kpiandheader[1];
    headersForVariation.forEach(element => {
      allHeaders.push(element);
    });

    const calculatedFilter = GetFilter(filters, this.state.filters, widgetName);

    kpis = await this.checkBudgetVisibility(kpis);
    const genericRequest = this.getGenericRequest(kpis, calculatedFilter, date);

    const responseData = await MakeGenericApiCall(
      headers,
      indicator,
      genericRequest,
      this.props.widgetConfiguration,
      this.state.correlationId
    );
    const errorStatus = CheckReponseDataForError(responseData);
    if (errorStatus) {
      this.setDataStatus(errorStatus);
      this.setStatusText(responseData.statusText);
      this.setState({
        data: [],
        headers: [],
      });
      return;
    }

    const result = MapData(responseData);
    this.handleResponseData(allHeaders, result, genericRequest);
  }

  private handleResponseData(
    allHeaders: any,
    result: NbiClientListOutput,
    genericRequest: IGenericRequest
  ) {
    if (result.data.length === 0) {
      this.setState({
        data: [],
        headers: [],
      });
      this.setDataStatus("no-data");
    } else if (
      genericRequest.aggregationAttributes &&
      genericRequest.kpis &&
      result.data.length *
        (genericRequest.aggregationAttributes.split(",").length +
          genericRequest.kpis.split(",").length) >=
        1000000
    ) {
      this.setDataStatus("client-request-error");
      this.setState({
        data: [],
        headers: [],
      });
    } else {
      this.setState({
        data: result.data,
        headers: allHeaders,
      });
      this.setDataStatus("ready");
    }
  }

  private async checkBudgetVisibility(kpis: any): Promise<any> {
    if (kpis.indexOf("gbis_bud") === -1) {
      return kpis;
    }
    const userRole = await MakeSalesCreditRoleProfile(
      this.props.headers,
      this.props.widgetConfiguration,
      indicator,
      this.state.correlationId
    );
    const validRoles = [
      "CustomDataUsersITECFullVisibility",
      "CustomDataUsersICVisibility",
    ];
    if (userRole && validRoles.indexOf(userRole.TechnicalRole) > -1) {
      return kpis;
    }
    const budgetKpis = [
      "nbi_gbis_bud_obj",
      "nbi_ytd_vs_nbi_gbis_bud_obj",
      "nbi_gbis_bud_obj_ib",
      "nbi_ytd_vs_nbi_gbis_bud_obj_ib",
    ];
    const kpiArray = kpis.split(",");
    const filteredAry = kpiArray.filter(
      (x: any) => budgetKpis.indexOf(x) === -1
    );
    return filteredAry.join();
  }

  private areFilterColumnsUnDefined(
    propsParam: PortfolioClientListProps
  ): boolean {
    return (
      propsParam.filters !== undefined &&
      (propsParam.filters.columns === undefined ||
        propsParam.filters.columns.length === 0)
    );
  }

  private columnOrderChanged(userPreferences: AgGridUserPreference) {
    if (
      userPreferences &&
      userPreferences.columns &&
      this.props.onColumnsMoved
    ) {
      this.props.onColumnsMoved(userPreferences);
    }
  }

  private checkClientFilters(nextProps: PortfolioClientListProps) {
    return (
      this.props.attribute === attr.CLIENT_GEN_ID &&
      ((this.props.filters !== undefined &&
        this.props.filters.value === undefined) ||
        (nextProps.filters !== undefined &&
          nextProps.filters.value === undefined) ||
        (this.areFilterColumnsUnDefined(nextProps) &&
          this.areFilterColumnsUnDefined(this.props)))
    );
  }

  private checkPortfolioFilters(nextProps: PortfolioClientListProps) {
    return (
      this.props.attribute === attr.CLIENT_CORIGRPCOMID &&
      ((this.props.filters !== undefined &&
        this.props.filters.value === undefined) ||
        (nextProps.filters !== undefined &&
          nextProps.filters.value === undefined))
    );
  }

  private checkClientGroupFilters(nextProps: PortfolioClientListProps) {
    return (
      this.props.attribute === attr.GRP_FULL_NAME &&
      ((this.props.filters !== undefined &&
        this.props.filters.value === undefined) ||
        (nextProps.filters !== undefined &&
          nextProps.filters.value === undefined))
    );
  }

  private getGenericRequest(
    kpi: string,
    filter: string,
    date: string
  ): IGenericRequest {
    const attrs = this.getAttributeswithMandatoryFields();
    return {
      aggregationAttributes: attrs,
      date,
      filter,
      kpis: kpi,
      sort: attrs,
    };
  }

  private getAttributeswithMandatoryFields(): string {
    const portfolioName = "clientgen_name";
    const portfolioID = "clientgen_id";
    const clientSubGroupName = "client_subgrpname";
    const clientSubGroupId = "client_subgrpid";
    const clientLegalEntityName = "client_lename";
    const clientLegalEntityId = "client_leid";
    const clientRctForLegalEntityName = "client_lerctcode";
    const clientGroupName = "client_grpname";
    const clientGroupId = "client_grpid";

    let attribute = this.state.visibleAttributes
      .map(x => x.field)
      .sort()
      .join(",");
    if (
      this.state.visibleAttributes.map(x => x.field).indexOf(portfolioName) >
        -1 &&
      this.state.visibleAttributes.map(x => x.field).indexOf(portfolioID) <= -1
    ) {
      attribute = `${attribute},${portfolioID}`;
    }

    if (
      this.state.visibleAttributes
        .map(x => x.field)
        .indexOf(clientSubGroupName) > -1 &&
      this.state.visibleAttributes
        .map(x => x.field)
        .indexOf(clientSubGroupId) <= -1
    ) {
      attribute = `${attribute},${clientSubGroupId}`;
    }

    if (
      (this.state.visibleAttributes
        .map(x => x.field)
        .indexOf(clientLegalEntityName) > -1 ||
        this.state.visibleAttributes
          .map(x => x.field)
          .indexOf(clientRctForLegalEntityName) > -1) &&
      this.state.visibleAttributes
        .map(x => x.field)
        .indexOf(clientLegalEntityId) <= -1
    ) {
      attribute = `${attribute},${clientLegalEntityId}`;
    }

    if (
      this.state.visibleAttributes.map(x => x.field).indexOf(clientGroupName) >
        -1 &&
      this.state.visibleAttributes.map(x => x.field).indexOf(clientGroupId) <=
        -1
    ) {
      attribute = `${attribute},${clientGroupId}`;
    }
    return attribute;
  }

  private checkKpisForVariation(filters: any[]) {
    const varKeys = [
      "nbi_ytd_var_yoy",
      "nbi_fy_var_yoy",
      "nbi_forcast_y1_var_yoy",
      "nbi_rwa_vs_fy_1",
      "nbi_forecast_rwa_y1_vs_fy_1",
      "nbi_forecast_rwa_y2_vs_fy_1",
      "nbi_rgcp_vs_fy_1",
      "nbi_ytd_vs_nbi_gbis_bud_obj",
      "nbi_ytd_vs_nbi_gbis_bud_obj_ib",
    ];

    const listOfKpisWithFields = filters.map((x: any) => x.field).sort();
    const listOfKpisNeededForVarGbisIb = this.addVarKpis(listOfKpisWithFields);
    const listWithOutGbisIbVar = filters
      .filter((x: any) => varKeys.indexOf(x.field) === -1)
      .map((x: any) => x.field)
      .sort();

    const headersWithVariation = this.getheadersWithVariation(
      listOfKpisNeededForVarGbisIb
    );
    return [
      listWithOutGbisIbVar.concat(listOfKpisNeededForVarGbisIb).join(","),
      headersWithVariation,
    ];
  }

  private getheadersWithVariation(listOfKpisNeededForVarGbisIb: any) {
    const kpiheaders = getAllHeaders("").kpiHeaders;
    return kpiheaders
      .filter((x: any) => listOfKpisNeededForVarGbisIb.indexOf(x.field) > -1)
      .map((x: any) => x)
      .sort();
  }

  private addVarKpis(arr: any[]) {
    const uniqueArray: any = [];
    for (const iterator of arr) {
      const a = this.getKpi(iterator);
      if (a.length > 0) {
        a.forEach(it => {
          if (arr.indexOf(it) === -1 && uniqueArray.indexOf(it) === -1) {
            uniqueArray.push(it);
          }
        });
      }
    }
    return uniqueArray;
  }

  private getKpi(varKpi: string) {
    const kpi = [];
    switch (varKpi) {
      case "nbi_ytd_var_yoy":
        kpi.push("nbi_ytd");
        kpi.push("nbi_ytd_1");
        break;
      case "nbi_fy_var_yoy":
        kpi.push("nbi_fy_1");
        kpi.push("nbi_ytd");
        break;
      case "nbi_forcast_y1_var_yoy":
        kpi.push("nbi_forcast_y1");
        kpi.push("nbi_fy_1");
        break;
      case "nbi_rwa_vs_fy_1":
        kpi.push("nbi_rwa_avg");
        kpi.push("nbi_rwa_fy_1");
        break;
      case "nbi_forecast_rwa_y1_vs_fy_1":
        kpi.push("nbi_forcast_rwa_y1");
        kpi.push("nbi_rwa_fy_1");
        break;
      case "nbi_rgcp_vs_fy_1":
        kpi.push("nbi_rgcp");
        kpi.push("nbi_rwa_fy_1");
        break;
      case "nbi_ytd_vs_nbi_gbis_bud_obj":
        kpi.push("nbi_ytd");
        kpi.push("nbi_gbis_bud_obj");
        break;
      case "nbi_ytd_vs_nbi_gbis_bud_obj_ib":
        kpi.push("nbi_ytd_ib");
        kpi.push("nbi_gbis_bud_obj_ib");
        break;
    }
    return kpi;
  }

  private isFromClientScreenCheck(
    nextProps: PortfolioClientListProps
  ): boolean {
    return (
      this.props.attribute === attr.CLIENT_GEN_ID ||
      (nextProps !== undefined && nextProps.attribute === attr.CLIENT_GEN_ID)
    );
  }

  private isFromGroupScreenCheck(nextProps: PortfolioClientListProps): boolean {
    return (
      this.props.attribute === attr.GRP_FULL_NAME ||
      (nextProps !== undefined && nextProps.attribute === attr.GRP_FULL_NAME)
    );
  }
}

/*
    Special Case:
    1. If pivot is Client Group or client snapshot : coverage inherit:0 will not be applied

    2. if pivot is portfolio
        a. client is not selected coverage inherit:0 will be applied
        b. client is selected coverage inherit:0 will not be applied
  */
export function GetFilter(
  filters: IFilterItem[],
  statefilters: string,
  widgetName: string
): string {
  const inheritedFilter = "coverage_inherited:0";
  if (widgetName === widgetNames.PORTFOLIO) {
    if (filters.filter(x => x.attribute === attr.CLIENT_GEN_ID).length === 0) {
      return statefilters
        ? `${statefilters},${inheritedFilter}`
        : inheritedFilter;
    }
  }
  return statefilters;
}

export const PortfolioClientList = withWidgetConfiguration(
  PortfolioClientListClass
);
